import enable_2fa from '../../../../assets/src/images/enable_2fa.png';
import { Image } from 'expo-image';
import { Box, VStack, HStack, Text } from 'native-base';
import { PrimaryButton, PointsTag } from '../../';
import { openModal, useAppDispatch } from '@breakroom-nx/redux';

export const Setup2FA = () => {
  const dispatch = useAppDispatch();

  return (
    <Box
      width={'full'}
      bg={'rgba(66, 211, 189, 0.40)'}
      px={'1.25rem'}
      py={'1.25rem'}
      rounded={10}
    >
      <VStack space={8} textAlign={'center'} alignItems={'center'}>
        <Image
          source={{ uri: enable_2fa }}
          cachePolicy={'memory-disk'}
          accessibilityLabel={`Enable 2FA Image`}
          style={{
            width: '90%',
            aspectRatio: 1,
          }}
        />
        <VStack space={2} textAlign={'center'} alignItems={'center'}>
          <Text
            fontFamily={'heading'}
            fontSize={23}
            color={'primary.400'}
            fontWeight={600}
            mb={'3px'}
          >
            Secure Your Account
          </Text>
          <Text
            fontFamily={'heading'}
            fontSize={16}
            color={'rgba(66, 211, 189, 0.60)'}
            fontWeight={600}
            mb={'3px'}
          >
            Enable two-factor authentication and receive SMS codes whenever you
            log in or make important security changes to your account
          </Text>
        </VStack>

        <VStack space={3} textAlign={'center'} alignItems={'center'}>
          <PrimaryButton
            onPress={() => dispatch(openModal({ modalType: 'Enable2FA' }))}
            text={'Setup 2FA'}
            bg={'primary.400'}
            color={'surface.100'}
          />
          <PointsTag amount={500} payment={true} fontSize={12} />
        </VStack>
      </VStack>
    </Box>
  );
};
